<template>
  <div :class="ns.b()">
    <z-segmented v-model="statusModel" :options="statusOptions" />
    <z-input
      v-model="keywordModel"
      clearable
      placeholder="搜索任务标题、描述、处理人"
      :class="ns.e('search')"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useNamespace } from '@zoryn/hooks'
import ZInput from '@zoryn/components/input'
import ZSegmented from '@zoryn/components/segmented'
import type { TaskFilterStatus } from '../types'

const props = defineProps<{
  filterStatus: TaskFilterStatus
  keyword: string
}>()

const emit = defineEmits<{
  'update:filterStatus': [value: TaskFilterStatus]
  'update:keyword': [value: string]
}>()

const ns = useNamespace('task-center-filter')

const statusOptions = [
  { label: '全部', value: 'all' },
  { label: '待办', value: 'pending' },
  { label: '进行中', value: 'processing' },
  { label: '已完成', value: 'done' },
  { label: '已逾期', value: 'overdue' },
]

const statusModel = computed({
  get: () => props.filterStatus,
  set: (value) => emit('update:filterStatus', value as TaskFilterStatus),
})

const keywordModel = computed({
  get: () => props.keyword,
  set: (value) => emit('update:keyword', value),
})
</script>
